import {Component, OnInit,} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {NbWindowService} from '@nebular/theme';
import {distinctUntilChanged, take, takeUntil} from 'rxjs/operators';
import {translations} from '../../../../environments/translations.ru';
import {PopupAddressComponent} from '../../modal-components/popup-address/popup-address.component';
import {BaseFieldType} from 'compob2b-libs';

@Component({
  selector: 'app-address-with-geo',
  templateUrl: './address-with-geo.component.html'
})
export class AddressWithGeoComponent extends BaseFieldType implements OnInit {
  addressForm = new FormGroup({
    address: new FormControl(null),
    latitude: new FormControl(null),
    longitude: new FormControl(null),
  });

  constructor(private readonly windowService: NbWindowService) {
    super();
  }

  openChooseAddressModal() {
    this.windowService.open(PopupAddressComponent, {
      title: translations.typeAddress,
      windowClass: 'add-address',
      context: {retrieveGeo: true}
    }).onClose.subscribe(address => {
      if (address) {
        this.formControl.setValue(address);
        this.addressForm.setValue(address);
        this.formControl.markAsTouched();
        this.addressForm.markAsTouched();
        this.cdr.detectChanges();
      }
    });
  }

  ngOnInit(): void {
    this.formControl.valueChanges
      .pipe(
        take(1),
      )
      .subscribe(address => {
        if (address) {
          this.addressForm.get('address').setValue(address);
        }
        this.cdr.detectChanges();
      });

    this.addressForm.valueChanges.pipe(takeUntil(this.unsubscribe), distinctUntilChanged()).subscribe(address => this.formControl.setValue({address}));
  }
}
